package com.patronat.top.library.media.data

import com.patronat.top.core.domain.models.DomainResult
import com.patronat.top.core.network.NetworkResult
import com.patronat.top.core.network.asDomainResult
import com.patronat.top.error.AppErrorCode
import com.patronat.top.dto.ImageType
import com.patronat.top.library.media.data.mappers.toDomain
import com.patronat.top.library.media.data.remote.MediaApi
import com.patronat.top.library.media.data.FileSource
import com.patronat.top.library.media.domain.models.FileRegistration
import com.patronat.top.library.media.domain.repository.MediaRepository

class MediaRepositoryImpl(
    private val api: MediaApi
) : MediaRepository {

    override suspend fun uploadImage(
        file: FileSource,
        type: ImageType,
        mimeType: String,
        onProgress: ((Float) -> Unit)?
    ): DomainResult<FileRegistration> {

        val uploadInfo = when (val urlNetworkResult = api.getUploadUrl(type, mimeType)) {
            is NetworkResult.Success ->DomainResult.Success(urlNetworkResult.data)
            is NetworkResult.Error -> return DomainResult.Error(
                type = urlNetworkResult.type,
                message = urlNetworkResult.message,
                throwable = urlNetworkResult.throwable
            )
        }

        try {
            api.uploadToS3(
                uploadUrl = uploadInfo.data.uploadUrl,
                file = file,
                contentType = mimeType,
                onProgress = { sent, total ->
                    val progress = if (total > 0) sent.toFloat() / total else 0f
                    onProgress?.invoke(progress)
                }
            )
        } catch (e: Exception) {
            return DomainResult.Error(
                type = AppErrorCode.INTERNAL_ERROR,
                message = "Failed to upload file to S3: ${e.message}",
                throwable = e
            )
        }

        val fileRegistration = api.registerFile(uploadInfo.data.fileKey, type)
        return fileRegistration.asDomainResult { it.toDomain() }

    }

}